<template>
  <div :class="windowWidth < 677 ? 'top-nav-wrap' : 'new-top-nav-wrap'">
    <div class="translate-nav-box">
      <Translate />
    </div>
    <div class="search-btn" @click="searchEmail"><img src="@/assets/svg/search.svg" alt="" /></div>
    <van-nav-bar :class="windowWidth < 677 ? 'home-top-nav' : 'new-home-top-nav'" :left-arrow="false" fixed>
      <template #title>
        <div class="home-title">
          <!-- <span @click="showPopup">{{ showTile }}</span> -->
          <span @click="showVc">{{ showTile }}</span>
        </div>
      </template>

      <!-- 右侧功能 -->
      <template #right>

        <van-popover v-model="showPopover" trigger="click" placement="bottom-end" :actions="actions" @select="navRightClick" @open="popoveOPen">
          <template #reference>
            <img class="home-nav-right" src="../../assets/svg/operate-.svg" alt="" />
          </template>
        </van-popover>
      </template>
    </van-nav-bar>
    <!-- 顶部分类 -->
    <van-popup v-model="show" position="top" :style="{ top: '45px' }">
      <div v-for="item in list" @click="popupClick(item)" :key="item.title" :class="windowWidth < 677 ? 'prop-item' : 'new-prop-item'">
        {{ item.title }}
      </div>
    </van-popup>
  </div>
</template>

<script>
import vconsole from 'vconsole'
import Translate from '@/components/translate/index.vue'

export default {
	components: { Translate },
	data() {
		return {
			list: [
				{
					title: '全部',
					itemKey: 0
				},
				{
					title: '未读邮件',
					itemKey: 1
				},
				{
					title: '星标邮件',
					itemKey: 2
				},
				{
					title: '有附件',
					itemKey: 3
				}
			],
			actions: [
				{
					text: '全部已读',
					itemKey: 'all'
				},
				{
					text: '选择邮件',
					itemKey: 'select'
				}
			],
			show: false,
			showPopover: false,
			showTile: '收件箱',
			showVcNum: 0
		}
	},
	props: {
		/* 邮件数据 */
		windowWidth: {
			type: Number,
			default: 0
		}
	},
	computed: {
		ListInfo() {
			return this.$store.state.List
		}
	},
	beforeMount() {
		this.getNotReadNumber({
			ParentFolderId: this.ListInfo.seachForm.ParentFolderId,
			DisplayName: this.ListInfo.DisplayName
		})
	},
	methods: {
		defaultStatus() {
			this.show = false
			this.showPopover = false
		},
		showVc() {
			this.showVcNum = this.showVcNum + 1
			if (this.showVcNum >= 8) {
				const vc = new vconsole()
			}
		},
		showPopup() {
			this.show = !this.show
		},
		popoveOPen() {
			/* 如果下拉分类是开启状态 先关闭 */
			if (this.show) {
				this.show = false
			}
		},
		/* 获取邮箱未读数 */
		getNotReadNumber(e) {
			console.log('cchuanguolai-------', e)
			if (!e || e.ParentFolderId === '0') {
				this.$api.getEmaNotRead({ isRefresh: true }).then((result) => {
					const { Data } = result
					let txt = this.$t('header.Inbox')
					if (Data && parseInt(Data) > 0) {
						let num = Data
						if (Data > 9999) {
							num = '9999+'
						}
						txt = txt + ` (${num})`
					}
					this.showTile = txt
				})
			} else {
				this.showTile = e.DisplayName
			}
		},
		popupClick(e) {
			console.log(e)
			const seachForm = { ...this.$store.state.seachForm }
			this.$store.commit('setSeachForm', {
				...seachForm,
				HasAttachments: true
			})
			this.show = false
			this.$emit('selectEmaByType')
		},
		navLeftClick() {
			this.$emit('navLeftClick')
		},
		navRightClick(e) {
			this.$emit('navRightClick', e)
		},
		searchEmail() {
			this.$emit('searchEmail')
		}
	}
}
</script>

<style lang="less" scoped>
.top-nav-wrap {
	height: 50px;
}
.new-top-nav-wrap {
	height: 45px;
}
.home-top-nav {
	// position: sticky;
	// top: 0;
	z-index: 2022;
	.home-nav-left {
		width: 22px;
		height: 22px;
	}
	.home-title {
		font-size: 18px;
	}
	.home-nav-right {
		width: 24px;
		height: 24px;
		margin-top: 8px;
	}
}
.new-home-top-nav {
	// position: sticky;
	// top: 0;
	z-index: 2022;
	.home-nav-left {
		width: 11px;
		height: 11px;
	}
	.home-title {
		font-size: 9px;
	}
	.home-nav-right {
		width: 12px;
		height: 12px;
	}
}
.prop-item {
	text-align: center;
	width: 100%;
	height: 46px;
	line-height: 46px;
	font-size: 16px;
	color: #191919;
	border-bottom: 1px solid #e5e5e5;
}
.new-prop-item {
	text-align: center;
	width: 100%;
	height: 23px;
	line-height: 23px;
	font-size: 8px;
	color: #191919;
	border-bottom: 0.5px solid #e5e5e5;
}
.prop-item.active {
}

.translate-nav-box {
	z-index: 10000;
	position: absolute;
	right: 45px;
	top: 15px;
}
.search-btn {
	z-index: 10000;
	position: absolute;
	right: 88px;
	top: 16px;
	> img {
		width: 16px;
		height: 16px;
	}
}
</style>
